import Vue     from 'vue'
import Router  from 'vue-router'
import Index   from "@/pages/index"
Vue.use(Router)

const routers = [
    // 商家入驻
    {
        path:'merchant',name:'merchant',component:()=>import('@/pages/merchant/index.vue')
    },
    //  繁淼充电桩
     {
        path:'energy',name:'energy',component:()=>import('@/pages/energy/index.vue')
    },
    // 入驻条件
    {
        path:'condition',name:'condition',component:()=>import('@/pages/condition/index.vue')
    },
    // 入驻资料
    {
        path:'profile',name:'profile',component:()=>import('@/pages/profile/index.vue')
    },
    // 嘉马民宿
    {
        path:'homestay',name:'homestay',component:()=>import('@/pages/homestay/index.vue')
    },
    // 嘉马商城
    {
        path:'gaMall',name:'gaMall',component:()=>import('@/pages/gaMall/index.vue')
    },
    // 物联平台
    {
        path:'internet',name:'internet',component:()=>import('@/pages/internet/index.vue')
    }
]

const router =  new Router({
    mode: 'history',
    routes: [
        { 
            path: '/',
            name: 'Index', 
            component: Index,
            redirect:"/gaMall",  //默认选中的子路由
            children:[
                ...routers
            ]
        }
    ]
})
export default router